import React from "react";
import { URL } from "screen/00_Nav/url";
import { Layout, Row, Col } from "antd";
import LayoutHeader from "screen/00_Nav/layout/layout_header";
import SectionCointaner from "component/sections/section_container";
import TriggerInit from "./trigger/trigger_init";
import MachineHeader from "./component/machine_header";
import MachineAdd from "./component/machine_add";
import MachineTable from "./component/machine_table";
import DialogMachineAdd from "./dialog/dialog_machine_add";

//
//component
//redux
//selector
//actions
//utils
//hook
//str

const breadCrum = [
  {
    title: "Home",
    url: null,
  },
  {
    title: "Virtual Machine",
    url: URL.vm,
  },
];

const VirtualMachine = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row gutter={[10, 20]}>
        <Col xl={18} lg={18} md={18} xs={24}>
          <MachineHeader />
        </Col>
        <Col align="right" xl={6} lg={6} md={6} xs={24}>
          <MachineAdd />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <MachineTable />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Layout id="bailiff-screen">
      <LayoutHeader title="Virtual Machine Management" />
      <SectionCointaner breadCrum={breadCrum}>
        <div style={{ padding: 24 }}>
          <Row justify={"center"}>
            <Col xl={24} lg={24} md={24} xs={24}>
              {renderBody()}
            </Col>
          </Row>
        </div>
      </SectionCointaner>
      <DialogMachineAdd />
      <TriggerInit />
    </Layout>
  );
};
export default VirtualMachine;
